export default {"src":"/_next/static/media/empty.146fe814.svg","height":239,"width":239,"blurWidth":0,"blurHeight":0};